"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withRefreshIfStale = exports.useRefreshIfStale = void 0;
const react_1 = __importStar(require("react"));
const polaris_1 = require("@amzn/awsui-components-react/polaris");
const DEFAULT_EXPIRATION_SECONDS = 3600;
const loadedAt = new Date();
exports.useRefreshIfStale = (location, expiresInSeconds = DEFAULT_EXPIRATION_SECONDS) => {
    const method = (location.state && location.state.method) || 'GET';
    const staleRef = react_1.useRef(false);
    const [refreshing, setRefreshing] = react_1.useState(false);
    react_1.useLayoutEffect(() => {
        let timer;
        const checkIfStale = async () => {
            try {
                // TODO: Allow passing in the path as a parameter to make this check more useful to apps other than
                //  ATMSProjectManagementWebUI
                const response = await fetch('/', { method: 'HEAD' });
                const lastModifiedHeader = response.headers.get('Last-Modified') || '';
                if (!lastModifiedHeader) {
                    console.warn(`No Last-Modified header; automatically refreshing on next transition`);
                }
                else if (new Date(lastModifiedHeader).getTime() < loadedAt.getTime()) {
                    // still current, check again later
                    timer = setTimeout(checkIfStale, expiresInSeconds * 1000);
                    return;
                }
            }
            catch (e) {
                console.error(e);
            }
            // reload if it's known to be stale or if we just can't tell due to an error.
            // note that we use a mutable ref so the we don't immediately refresh; we wait for a safe navigation event (i.e. GET a url)
            staleRef.current = true;
            return;
        };
        timer = setTimeout(checkIfStale, expiresInSeconds * 1000);
        return () => clearTimeout(timer);
    }, [expiresInSeconds]);
    react_1.useLayoutEffect(() => {
        if (!staleRef.current)
            return;
        if (refreshing)
            return;
        if (method !== 'GET')
            return;
        setRefreshing(true);
        console.log('New version of the app detected, automatically reloading');
        window.location.reload();
    }, [location.pathname, method, refreshing]);
    return refreshing;
};
// reload the page if the js is out of date, but only on URL changes
exports.withRefreshIfStale = (Component, expiresInSeconds = DEFAULT_EXPIRATION_SECONDS) => ({ location, ...props }) => {
    const refreshing = exports.useRefreshIfStale(location, expiresInSeconds);
    if (refreshing) {
        return react_1.default.createElement(polaris_1.Spinner, { size: "large" });
    }
    else {
        return react_1.default.createElement(Component, Object.assign({ location: location }, props));
    }
};
//# sourceMappingURL=refreshIfStale.js.map